import React from 'react';
import { styles } from './CheckoutSurveyPage.css';

export type CheckoutSurveyPageProps = {
  surveyUrl: string;
};

export const CheckoutSurveyPage = ({ surveyUrl }: CheckoutSurveyPageProps) => {
  const searchParams = new URL(window.location.href).searchParams;

  return (
    <iframe
      className={styles.iframe}
      title="checkout-survey"
      src={`${surveyUrl}${searchParams.size ? `?${searchParams}` : ''}`}
    ></iframe>
  );
};
